import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, programManagementURL } from '../../../../../Containers/Config/index.js';
import { GET_SPOCS, GET_SPOCS_ERROR, GET_SPOCS_SUCCESS } from '../../../actionType.js';
import apiCall from '../../../apiCall.js';

function* getSpocs({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${programManagementURL}/api/v1/spocs`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.urlParam,
    });

    if (response.status === 200) {
      yield put({
        type: GET_SPOCS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_SPOCS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_SPOCS_ERROR, payload: error });
  }
}

export function* watchGetSpocs() {
  yield takeEvery(GET_SPOCS, getSpocs);
}

function* getSpocsSaga() {
  yield all([fork(watchGetSpocs)]);
}

export default getSpocsSaga;
